import generator from '../util/generator';

export default generator.generate('', 'display', [
    ['hidden', 'none'],
    'flex',
]);
